/* Menu lateral scripts
========================================================================== */

// FUNCIONALIDADES DEL MENU LATERAL
if (document.getElementById('btn-menu-flecha-lateral')) {
	document.getElementById('btn-menu-flecha-lateral').addEventListener('click', abrir_cerrar_menu_lateral_izquierdo);
	document.getElementById('btn-menu-flecha-esquina-derecha').addEventListener('click', abrir_cerrar_menu_lateral_izquierdo);
	
	function abrir_cerrar_menu_lateral_izquierdo() {
		document.getElementById('menu-lateral').classList.toggle('menu-cerrado');
	}

	/* if (screen.width < 1000) {
		document.getElementById('menu-lateral').classList.toggle('menu-cerrado');
	} */
}
